import React from "react";
import "../../css/el-loader.css";

export const ElLoader = () => {
  return (
    <div className="elcontainer">
      <div className="loader"></div>
    </div>
  );
};
